class HeaderNav {
  private elements: any;
  private $element: any;

  constructor() {
    this.$element = jQuery(document.querySelector(".grav-header"));
    this.elements = this.getDefaultElements();

    // Manually bind events
    this.bindEvents();

    // Initialize accessibility attributes
    this.elements.$mobileNav.attr("aria-hidden", "true");
    this.elements.$hamburgerButton.attr("aria-expanded", "false");
  }

  private getDefaultElements() {
    return {
      $mobileNav: this.$element.find(".mobile-nav"),
      $desktopNav: this.$element.find(".desktop-nav"),
      $hamburgerButton: this.$element.find(".hamburger-button"),
    };
  }

  private bindEvents() {
    this.elements.$hamburgerButton.on("click", this.toggleNav.bind(this));

    //handle clicks on desktop nav
    this.elements.$desktopNav.on(
      "click",
      ".menu-item-has-children > a",
      (e: JQuery.ClickEvent) => {
        console.log("clicked a dropdown", e.currentTarget);
        //note that if you enable elementor page transitions,
        //e.preventDefault won't work, and neither will e.stopImmediatePropagation.
        //need to work out another way.
        e.preventDefault();

        //handle closing logic. Toggle the current item, close the others.
        const $parent = jQuery(e.currentTarget).parent();
        const $siblings = $parent.siblings(".menu-item-has-children");
        $parent.toggleClass("open");
        $siblings.removeClass("open");
      }
    );

    // close the menu if you click outside of a submenu
    jQuery(document).on("click", (e: JQuery.ClickEvent) => {
      if (jQuery(e.target).closest(".desktop-nav").length === 0) {
        this.elements.$desktopNav
          .find(".menu-item-has-children")
          .removeClass("open");
      }
    });

    this.elements.$mobileNav.on(
      "click",
      "a:not(.menu-item-has-children > a, .sub-menu-title > a, .subtitle a)",
      this.closeNavOnLinkClick.bind(this)
    );

    // Handle taps on menu items with children on mobile
    this.elements.$mobileNav.on(
      "click",
      ".menu-item-has-children:not(.sub-menu-title) > a",
      this.handleChildMenuClick.bind(this)
    );

    // Handle sub-menu-title
    this.elements.$mobileNav.on(
      "click",
      ".sub-menu-title > a",
      this.handleBackClick.bind(this)
    );

    // Close menu when escape key is pressed
    jQuery(document).on("keydown", this.handleEscapePress.bind(this));
  }

  private handleBackClick(e: JQuery.ClickEvent) {
    // Or whatever breakpoint you're using for mobile
    e.preventDefault();
    console.log(
      "handleBackClick",
      jQuery(e.currentTarget),
      jQuery(e.currentTarget).closest(".open")
    );
    jQuery(e.currentTarget).closest(".open").removeClass("open");
  }

  private handleChildMenuClick(e: JQuery.ClickEvent) {
    // Or whatever breakpoint you're using for mobile
    console.log("handleChildMenuClick", e.currentTarget);
    e.preventDefault();
    jQuery(e.currentTarget).parent().toggleClass("open");
  }
  private handleEscapePress(event: JQuery.KeyDownEvent) {
    if (event.key === "Escape") {
      this.closeNav();
    }
  }

  private toggleNav() {
    const isOpen = this.elements.$mobileNav
      .toggleClass("open")
      .hasClass("open");
    this.elements.$hamburgerButton.toggleClass("open");
    document.body.classList.toggle("nav-open");

    // Update accessibility attributes
    this.elements.$mobileNav.attr("aria-hidden", !isOpen ? "true" : "false");
    this.elements.$hamburgerButton.attr(
      "aria-expanded",
      isOpen ? "true" : "false"
    );
  }

  private closeNavOnLinkClick() {
    this.closeNav();
  }

  private closeNav() {
    this.elements.$mobileNav.removeClass("open");
    this.elements.$hamburgerButton.removeClass("open");
    document.body.classList.remove("nav-open");

    // Update accessibility attributes
    this.elements.$mobileNav.attr("aria-hidden", "true");
    this.elements.$hamburgerButton.attr("aria-expanded", "false");
  }
}

// Using the class with jQuery:
jQuery(function ($) {
  new HeaderNav();
});
